import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Ensure all fields are filled
    if (!formData.name || !formData.email || !formData.message) {
      alert("Please fill out all fields before submitting.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch("https://agpipefitting.org.et/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      setLoading(false);

      if (response.ok) {
        alert("Your message has been sent to the admin. Thank you for reaching out!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
      alert("Unable to submit the form. Please check your network connection.");
    }
  };

  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-lg-5 mb-4">
          <div className="contact-info p-4 bg-light shadow rounded">
            <h3 className="text-dark">Contact Us</h3>
            <p className="text-muted">
              We are here to assist you with any inquiries. Reach out using the form or directly via phone or email.
            </p>
            <div>
              <p>
                <strong>Address:</strong> East Africa , Ethiopia , Bahir Dar 
              </p>
              <p>
                <strong>Phone:</strong> +251930415372 / 947090514 / 900863252
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <a href="mailto:info@agpipefitting.com" className="text-primary">
                  agpipefittingtechnology@gmail.com
                </a>
              </p>
              <p>
                <strong>Location:</strong>{" "}
                East Africa , Ethiopia , BahirDar 
              </p>
              <div className="social-icons mt-4">
                <a href="#" className="text-primary me-3">
                  <i className="bi bi-facebook fs-5"></i> Facebook
                </a>
                <a href="#" className="text-info me-3">
                  <i className="bi bi-twitter fs-5"></i> Twitter
                </a>
                <a href="#" className="text-primary">
                  <i className="bi bi-linkedin fs-5"></i> LinkedIn
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-5">
          <div className="contact-form p-4 bg-light shadow rounded">
            <h4 className="text-dark">Send Us a Message</h4>
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3">
                <label htmlFor="name" className="form-label">
                  Full Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-control"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group mb-3">
                <label htmlFor="email" className="form-label">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group mb-3">
                <label htmlFor="message" className="form-label">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  className="form-control"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="btn btn-primary w-100 py-2"
                disabled={loading}
              >
                {loading ? "Sending..." : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
